// extracted by mini-css-extract-plugin
module.exports = {"priceHistory":"price-history_priceHistory__uxJZk","reportButton":"price-history_reportButton__7dfIO","down":"price-history_down__BvV_u","up":"price-history_up__qNt6S"};